var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.132,
    height: 63.756,
    viewBox: "0 0 60.132 63.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6273",
    "data-name": "Group 6273",
    transform: "translate(-14.173 -20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8749",
    "data-name": "Path 8749",
    d: "M17.923,299.24v-2.473H15.072v2.473h-.9V293.6h.9v2.38h2.851V293.6h.9v5.642Z",
    transform: "translate(0 -215.52)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8750",
    "data-name": "Path 8750",
    d: "M46.021,299.24V293.6h3.013l-.274.771H46.92v1.6h1.831v.771H46.92v1.727h2.123v.771Z",
    transform: "translate(-25.091 -215.52)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8751",
    "data-name": "Path 8751",
    d: "M69.11,299.24V293.6H70v4.871h2.065v.771Z",
    transform: "translate(-43.283 -215.52)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6273-2",
    "data-name": "Group 6273",
    transform: "translate(30.05 78.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8752",
    "data-name": "Path 8752",
    d: "M90.685,299.129a2.988,2.988,0,0,1-1.669-.487l.377-.677a2.237,2.237,0,0,0,1.258.421c.461,0,1-.208,1-.721,0-.866-1.361-1.035-2.047-1.8a1.433,1.433,0,0,1-.384-1.008,1.568,1.568,0,0,1,1.772-1.51,2.828,2.828,0,0,1,1.335.31l-.009.838a2.53,2.53,0,0,0-1.284-.392c-.488,0-.891.2-.891.649,0,1.114,2.466,1.082,2.466,2.809,0,.951-.838,1.567-1.926,1.567",
    transform: "translate(-89.016 -293.348)",
    fill: "#e40613"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3902",
    "data-name": "Rectangle 3902",
    width: 0.898,
    height: 5.642,
    transform: "translate(35.436 78.077)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6274",
    "data-name": "Group 6274",
    transform: "translate(38.442 35.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8753",
    "data-name": "Path 8753",
    d: "M132.688,299.24l-2.656-3.466a8.44,8.44,0,0,1-.564-.815h-.017c.017.19.017.464.017.737v3.544h-.89V293.6h.908l2.55,3.339a6.874,6.874,0,0,1,.591.849h.017c-.009-.233-.017-.515-.017-.791v-3.4h.9v5.642Z",
    transform: "translate(-128.578 -251.108)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8754",
    "data-name": "Path 8754",
    d: "M162.494,299.129a2.7,2.7,0,0,1-2.823-2.833,2.872,2.872,0,0,1,3.063-2.948,4.18,4.18,0,0,1,1.637.319l-.009.864a3.427,3.427,0,0,0-1.567-.42,1.967,1.967,0,0,0-2.157,2.1,2,2,0,0,0,2.087,2.157,2.03,2.03,0,0,0,.952-.188v-1.943h.9v2.4a4.561,4.561,0,0,1-2.08.5",
    transform: "translate(-153.075 -250.911)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8755",
    "data-name": "Path 8755",
    d: "M193.978,299.241h-1.662V293.6h1.712a1.422,1.422,0,0,1,1.576,1.388,1.267,1.267,0,0,1-.718,1.2v.005a1.392,1.392,0,0,1,1.077,1.371c0,.789-.539,1.678-1.985,1.678m-.762-4.862v1.6h.641a.811.811,0,0,0,.831-.821c0-.473-.282-.78-.9-.78Zm.762,2.372h-.762v1.72h.719c.73,0,1.1-.359,1.1-.9,0-.477-.4-.82-1.054-.82",
    transform: "translate(-178.795 -251.11)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8756",
    "data-name": "Path 8756",
    d: "M216.584,294.172a2.994,2.994,0,0,1,4.186.059,3.162,3.162,0,0,1-.1,4.11,2.821,2.821,0,0,1-2.038.788,2.708,2.708,0,0,1-2.85-2.861,2.941,2.941,0,0,1,.8-2.1m2.045-.044a2.132,2.132,0,1,0,1.893,2.126,1.888,1.888,0,0,0-1.893-2.126",
    transform: "translate(-197.281 -250.911)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8757",
    "data-name": "Path 8757",
    d: "M253.372,299.24c-.882-1.454-1.318-2.225-1.54-2.286h-.523v2.286h-.9V293.6h1.4c1.412,0,1.953.71,1.953,1.576a1.591,1.591,0,0,1-1.062,1.49v.008a14.359,14.359,0,0,1,1.713,2.568Zm-1.549-4.863h-.514v1.875h.532a.985.985,0,0,0,1.009-.984c0-.487-.3-.891-1.028-.891",
    transform: "translate(-224.566 -251.108)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8758",
    "data-name": "Path 8758",
    d: "M277.337,299.129a2.7,2.7,0,0,1-2.826-2.833,2.875,2.875,0,0,1,3.064-2.948,4.165,4.165,0,0,1,1.636.319l-.007.864a3.43,3.43,0,0,0-1.568-.42,1.969,1.969,0,0,0-2.159,2.1,2.156,2.156,0,0,0,3.039,1.968v-1.943h.9v2.4a4.569,4.569,0,0,1-2.08.5",
    transform: "translate(-243.554 -250.911)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8759",
    "data-name": "Path 8759",
    d: "M154.675,101.414h0a.331.331,0,1,1-.331.331.332.332,0,0,1,.331-.331",
    transform: "translate(-148.878 -99.692)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8760",
    "data-name": "Path 8760",
    d: "M154.006,94.585a2.724,2.724,0,0,0,0-.758.835.835,0,0,1-.411.1,1.2,1.2,0,0,1,.184-.633,1.125,1.125,0,0,1-.874,0,1.206,1.206,0,0,1,.184.633.836.836,0,0,1-.411-.1,2.724,2.724,0,0,0,0,.758.838.838,0,0,1,.411-.105.972.972,0,0,1-.165.552l.036.027a.48.48,0,0,1,.764,0l.036-.027a.97.97,0,0,1-.165-.552.837.837,0,0,1,.411.105",
    transform: "translate(-147.545 -93.298)",
    fill: "#e40613"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8761",
    "data-name": "Path 8761",
    d: "M143.841,105.126l-3.248,2.528V108.7h.915v-1.044h1.877V108.7h.914v-1.044h1.877V108.7h.914v-1.044Z",
    transform: "translate(-99.602 -67.029)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8762",
    "data-name": "Path 8762",
    d: "M142.389,119.31v1.045h-1.877V119.31H139.6v1.045h-1.877V119.31h-.914v1.045H134.93V119.31h-.914v1.942H143.3V119.31Z",
    transform: "translate(-94.42 -78.205)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6275",
    "data-name": "Group 6275",
    transform: "translate(33.719 42.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8763",
    "data-name": "Path 8763",
    d: "M106.312,124.248a.388.388,0,1,1,.388.388.388.388,0,0,1-.388-.388",
    transform: "translate(-106.312 -123.86)",
    fill: "#e40613"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8764",
    "data-name": "Path 8764",
    d: "M98.116,130.009v-1.388h-.388v1.388l-2.557,3.269h8.553v-3.269Z",
    transform: "translate(-63.815 -85.54)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6276",
    "data-name": "Group 6276",
    transform: "translate(32.902 42.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8765",
    "data-name": "Path 8765",
    d: "M108.227,154.819h-.97v-1.065a.5.5,0,0,1,.97,0Zm-1.776,0h-.97v-1.065a.5.5,0,0,1,.97,0Zm-1.776,0h-.97v-1.065a.5.5,0,0,1,.97,0Zm-2.212.795h7.006V152.84h-7.006Z",
    transform: "translate(-102.463 -146.692)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8766",
    "data-name": "Path 8766",
    d: "M202.62,124.248a.388.388,0,1,0-.388.388.388.388,0,0,0,.388-.388",
    transform: "translate(-180.762 -123.86)",
    fill: "#e40613"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8767",
    "data-name": "Path 8767",
    d: "M181.929,130.009v-1.388h.388v1.388l2.558,3.269H176.32v-3.269Z",
    transform: "translate(-127.75 -85.54)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6277",
    "data-name": "Group 6277",
    transform: "translate(26.587 20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8768",
    "data-name": "Path 8768",
    d: "M177.562,153.754a.5.5,0,0,1,.97,0v1.065h-.97Zm1.776,0a.5.5,0,0,1,.97,0v1.065h-.97Zm1.776,0a.5.5,0,0,1,.97,0v1.065h-.97Zm-4.795,1.86h7.006V152.84H176.32Z",
    transform: "translate(-154.337 -124.671)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8769",
    "data-name": "Path 8769",
    d: "M95,172.018l3.976-3.834H91.782s-2.43.839-2.43,2.69a1.864,1.864,0,0,0,.435,1.144Z",
    transform: "translate(-85.817 -136.76)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8770",
    "data-name": "Path 8770",
    d: "M181.068,172.018l-3.976-3.834h7.194s2.43.839,2.43,2.69a1.863,1.863,0,0,1-.435,1.144Z",
    transform: "translate(-154.945 -136.76)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8771",
    "data-name": "Path 8771",
    d: "M132.8,160.649,128.07,154.4l6.4,6.351a1.99,1.99,0,0,1-.726.132,1.722,1.722,0,0,1-.945-.237m-2.306,0-3.07-6.518,4.836,6.6a1.959,1.959,0,0,1-.8.161,2.131,2.131,0,0,1-.969-.24m-2.378-.015-1.167-6.709,3.05,6.787a1.74,1.74,0,0,1-.814.176,3.275,3.275,0,0,1-1.069-.255m-1.543.255a2.4,2.4,0,0,1-1.069-.191l1.069-6.947,1.069,6.947a2.4,2.4,0,0,1-1.069.19m-3.425-.176,3.05-6.788-1.167,6.709a3.279,3.279,0,0,1-1.069.255,1.747,1.747,0,0,1-.814-.176m-2.261.015,4.836-6.6-3.07,6.519a2.1,2.1,0,0,1-.968.24,1.964,1.964,0,0,1-.8-.161m-2.21.029,6.4-6.351-4.733,6.247a1.725,1.725,0,0,1-.945.237,1.985,1.985,0,0,1-.726-.132",
    transform: "translate(-108.925 -125.386)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8772",
    "data-name": "Path 8772",
    d: "M98.169,191.117H97.2v-1.065a.5.5,0,0,1,.97,0Zm-4.522-1.065a.5.5,0,0,1,.97,0v1.065h-.97Zm1.776,0a.5.5,0,0,1,.97,0v1.065h-.97Zm2.636-1.525H92.942v4.783H93.6v1.883h3.06V193.31h2.21v-4.555a2.263,2.263,0,0,1-.814-.228",
    transform: "translate(-88.646 -152.787)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8773",
    "data-name": "Path 8773",
    d: "M191.611,190.054a.5.5,0,0,1,.97,0v1.066h-.97Zm4.522,1.066h-.97v-1.066a.5.5,0,0,1,.97,0Zm-1.776,0h-.97v-1.066a.5.5,0,0,1,.97,0Zm-3.451-2.363v4.555h2.21V195.2h3.06v-1.883h.661v-4.783H191.72a2.276,2.276,0,0,1-.814.228",
    transform: "translate(-165.829 -152.789)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8774",
    "data-name": "Path 8774",
    d: "M135.771,192.006h-1.286v-1.831a.66.66,0,0,1,1.286,0Zm-2.244,0h-1.595v-1.96a.818.818,0,0,1,1.595,0Zm-2.611,0h-1.6v-1.96a.818.818,0,0,1,1.6,0Zm-2.612,0h-1.595v-1.96a.818.818,0,0,1,1.595,0Zm-2.553,0h-1.285v-1.831a.659.659,0,0,1,1.285,0Zm10.4-3.687a2.367,2.367,0,0,1-1.141.276,2.61,2.61,0,0,1-1.159-.278,2.166,2.166,0,0,1-1.118.278,3.727,3.727,0,0,1-1.244-.287,2.649,2.649,0,0,1-1.363.287h-.009a2.65,2.65,0,0,1-1.363-.287,3.727,3.727,0,0,1-1.244.287,2.171,2.171,0,0,1-1.119-.278,2.608,2.608,0,0,1-1.158.278,2.368,2.368,0,0,1-1.141-.276,2.2,2.2,0,0,1-.914.266v4.552h1.691v1.883h3.06v-1.883h4.383v1.883h3.061v-1.883h1.692v-4.552a2.2,2.2,0,0,1-.914-.266",
    transform: "translate(-112.466 -152.614)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8775",
    "data-name": "Path 8775",
    d: "M140.317,132.653h-.97v-1.065a.5.5,0,0,1,.97,0Zm.806-1.065a.5.5,0,0,1,.97,0v1.065h-.97Zm1.776,0a.5.5,0,0,1,.97,0v1.065h-.97Zm-2.087,2.367.8-.8.8.8-.588.588,3.642,3.513v-7.323h-7.7v7.323l3.642-3.513Z",
    transform: "translate(-123.956 -107.254)",
    fill: "#e40613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8776",
    "data-name": "Path 8776",
    d: "M106.959,61.233H103.7v1.883H99.316V61.233H96.256v1.883H91.873V61.233h-3.06v1.883H84.43V61.233h-3.06v1.883H76.986V61.233h-3.26V34.253h33.233Zm-.15-41.184v.518h-.8v-.518h-1.186v.518h-.8v-.518h-1.186v1.394h.534v2.125h-.879V25h-1.559V23.568h-.88V21.443h.534V20.049H99.4v.518h-.8v-.518H97.415v.518h-.8v-.518H95.428v1.394h.534v2.125h-.879V25H93.267V23.568h-.879V21.443h.534V20.049H91.737v.518h-.8v-.518H89.75v.518h-.8v-.518H87.763v1.394H88.3v2.125h-.88V25H85.731V23.568h-.879V21.443h.534V20.049H84.2v.518h-.8v-.518H82.213v.518h-.8v-.518H80.227v1.394h.534v2.125h-.879V25H78.194V23.568h-.879V21.443h.535V20.049H76.664v.518h-.8v-.518H74.677v.518h-.8v-.518H72.69v1.394h.534V25l2.062,2.192v3.435H74.262V33.94h-.848V65.883c0,2.005,1.006,3.18,3.165,3.7,3.333.8,8.007,1.917,11.341,2.72A2.953,2.953,0,0,1,90.2,74.319l.147.416.148-.416A2.952,2.952,0,0,1,92.767,72.3c3.331-.8,8.005-1.922,11.341-2.72,2.159-.517,3.165-1.692,3.165-3.7V33.94h-.849V30.624H105.4V27.189L107.461,25V21.443H108V20.049Z",
    transform: "translate(-72.69 -20.049)",
    fill: "#e40613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3abac33d8665edf37c09aef0460f7b4.svg";
export { ForwardRef as ReactComponent };